import {faTimesCircle} from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';
import {Text} from '../Text';

type Props = {
  tag?: Parameters<typeof Text>[0]['tag'];
  className?: string;
  children: React.ReactNode;
};

export function FormError(props: Props): React.JSX.Element {
  const className = clsx(props.className, 'mt-2');

  return (
    <Text as="error" className={className} tag={props.tag}>
      <Icon icon={faTimesCircle} className="mr-1" />
      {props.children}
    </Text>
  );
}

FormError.displayName = 'FormError';
